import { FC, memo } from 'react';
import { useFormikContext } from 'formik';
import { PlaygroundConfig } from 'modules/Playground/types/playgroundConfig';
import { cx } from '@linaria/core';
import { useCompareMode } from 'modules/Playground/hooks/utils/useCompareMode';
import { styles, compareOverrides } from './PanelManager.styled';
import { Panel } from './Panel';
export const PanelManager: FC = memo(() => {
  const {
    values
  } = useFormikContext<PlaygroundConfig>();
  const {
    isCompareMode,
    onCompareModeToggle
  } = useCompareMode();
  return <div className={cx(styles.playgroundContainer, isCompareMode && compareOverrides)}>
      <div className={styles.compareContainer}>
        {/* Left Panel - Isolated Formik state */}
        <Panel panelId="left" initialValue={values} />

        {/* Right Panel - Conditionally rendered based on isCompareMode */}
        {isCompareMode && <Panel panelId="right" initialValue={values} onCompareModeToggle={onCompareModeToggle} asyncInitialization />}
      </div>
    </div>;
});